import {
  fetchingError,
} from '../../../shared/store/actions';
import {
  fetchReportDataForGroup as fetchReportDataForGroupApi,
  fetchObligations as fetchObligationsApi,
} from '../../api';
import { errorNotification } from '../../../shared/store/notificationActions';
import { fetchActionFactory } from '../../../shared/store/fetchFactory';
import {
  FETCHING_TAX_RESERVE_REPORT,
  FETCHING_TAX_RESERVE_REPORT_SUCCESS,
  FETCHING_TAX_RESERVE_REPORT_FAILURE,
  FETCHING_TAX_RESERVE_REPORT_DATA_FOR_ALL_PILLS,
  FETCHING_TAX_RESERVE_REPORT_DATA_FOR_ALL_PILLS_SUCCESS,
  FETCHING_TAX_RESERVE_REPORT_DATA_FOR_ALL_PILLS_FAILURE,
  FETCH_OBLIGATIONS,
} from './types';
import downloadXlsxBSMReport from '../../viewDeferredRollforwardPage/downloadXlsxBSMReport';
import downloadCsvBSMReport from '../../viewDeferredRollforwardPage/downloadCsvBSMReport';
import { BookTypePills, BookTypePillTypes } from '../../../shared/bookTypePills';

import { reportName } from '../constants';
import { getUpdateEditedCellAction, getRevertEditedCellsAction } from '../../shared/groupedReportsStoreHelpers';

export const { updateEditedCellForGroup } = getUpdateEditedCellAction(reportName);
export const { revertEditedCellsForGroup } = getRevertEditedCellsAction(reportName);

export const fetchObligations = fetchActionFactory(
  FETCH_OBLIGATIONS,
  fetchObligationsApi,
  { field: 'obligations' }
);

export const fetchReportDataForViewTaxReservePage = ({
  periodFrom,
  periodTo,
  slGroupType,
  slGroupItem,
  countryTaxType,
  bookType,
  reportingCurrency,
  currentPeriod,
}) => async dispatch => {
  dispatch({ type: FETCHING_TAX_RESERVE_REPORT });

  try {
    const reportData = await fetchReportDataForGroupApi({
      reportName: 'TaxReserve',
      fromPeriod: periodFrom.name,
      toPeriod: periodTo.name,
      groupType: slGroupType.value,
      groupItem: slGroupItem.value,
      countryTaxType: countryTaxType.value,
      bookType,
      reportingCurrency,
    });

    await dispatch(fetchObligations(currentPeriod));

    dispatch({
      type: FETCHING_TAX_RESERVE_REPORT_SUCCESS,
      reportData,
    });
  } catch (error) {
    dispatch({ type: FETCHING_TAX_RESERVE_REPORT_FAILURE });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

const buildTaxReserveExportPayload = async (
  periodFrom,
  periodTo,
  slGroupType,
  slGroupItem,
  countryTaxType,
  reportingCurrency,
  bookTypes,
  hideDecimals,
  shouldDisplayZero,
  negativeMinus,
  environmentSuffix
) => {
  const filteredBookTypes = BookTypePills
    .filter(({ type }) => bookTypes.includes(type))
    .map(({ type }) => type);

  const filteredBookTypesList = [
    ...filteredBookTypes,
    ...(filteredBookTypes.length && bookTypes.includes(BookTypePillTypes.STAT) ? ['ALL'] : []),
  ];

  const responses = await Promise.all(
    filteredBookTypesList.map(bookType => fetchReportDataForGroupApi({
      reportName: 'TaxReserveForExport',
      fromPeriod: periodFrom.name,
      toPeriod: periodTo.name,
      groupType: slGroupType.value,
      groupItem: slGroupItem.value,
      countryTaxType: countryTaxType.value,
      bookType,
      reportingCurrency,
    }))
  );

  const reports = filteredBookTypesList.reduce(
    (accu, bookType, index) => ({ ...accu, [bookType]: responses[index] }),
    {}
  );

  const fileName = `TLS_Tax_Reserve_${periodFrom.value}_${periodTo.value}_${countryTaxType.value}_${slGroupItem.value}${environmentSuffix}`;
  const description = `From ${periodFrom.name} to ${periodTo.name}, Country Tax Type: ${countryTaxType.value}, ${slGroupType.label}: ${slGroupItem.label}, Currency: ${reportingCurrency}`;

  return {
    reportTitle: 'Tax Reserve',
    reportData: {
      GAAP: reports[BookTypePillTypes.GAAP],
      GAAP_TO_STAT: reports[BookTypePillTypes.GAAP_TO_STAT],
      STAT: reports[BookTypePillTypes.STAT],
      ALL: reports.ALL,
    },
    description,
    fileName,
    hideDecimals,
    shouldDisplayZero,
    negativeMinus,
  };
};

const runTaxReserveExport = download => (...args) => async dispatch => {
  dispatch({
    type: FETCHING_TAX_RESERVE_REPORT_DATA_FOR_ALL_PILLS,
  });

  try {
    const payload = await buildTaxReserveExportPayload(...args);
    await download(payload);

    dispatch({
      type: FETCHING_TAX_RESERVE_REPORT_DATA_FOR_ALL_PILLS_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: FETCHING_TAX_RESERVE_REPORT_DATA_FOR_ALL_PILLS_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const exportToExcel = runTaxReserveExport(downloadXlsxBSMReport);
export const exportToCsv = runTaxReserveExport(downloadCsvBSMReport);
